import React, { useEffect, useState } from 'react';
import { Link, withRouter, useHistory } from "react-router-dom";
import Api from '../../Services/Api';
import './Login.css';

export const Login = (props) => {
    let [email, setEmail] = useState('');
    let [password, setPassword] = useState('');
    let [success, setSuccess] = useState('');
    let [fail, setFail] = useState('');
    let history = useHistory();
    useEffect(() => {
        if (localStorage.getItem('admin')) {
            history.push("/dashboard");
        }
    }, []);
    const doLogin = async () => {
        var data = { email: email, password: password };
        Api.post('login', data).then(resp => {
            var respData = resp.data;
            if (respData.status == 1) {

                setSuccess(respData.message);
                localStorage.setItem('authToken', respData.data.auth_token);
                localStorage.setItem("admin", JSON.stringify(respData.data));
                setTimeout(function () {
                    history.push("/dashboard");
                }, 1500);

            } else {
                setFail(respData.message);
            }
        }).catch((error) => {
            console.log(error);
            setFail(error.message);
        });
    }
    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="header-content">
                        <div className="login-logo-header">
                            <img src="./assets/images/logo-small.png" alt="Logo" />
                        </div>
                        <div className="header-text">
                            <h5>Welcome Back !</h5>
                            <p>Sign in to continue to Shubham999.</p>
                        </div>
                    </div>
                </div>
                <div className="login-body">


                    {fail ? <div className='alert alert-danger'>{fail}</div> : ''}
                    {success ? <div className='alert alert-success'>{success}</div> : ''}

                    <form>
                        <div className="form-group">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                placeholder="Enter Email"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password" className="form-label">Password</label>
                            <div className="input-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    placeholder="Enter password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                />
                            </div>
                        </div>

                        <div className="form-check mb-3">
                            <input className="form-check-input" type="checkbox" id="remember-check" />
                            <label className="form-check-label ms-2" htmlFor="remember-check">
                                Remember me
                            </label>
                        </div>

                        <button
                            className="login-btn"
                            type="button"
                            onClick={() => doLogin()}
                        >
                            Log In
                        </button>

                        <div className="mt-4 text-center">
                            {/* Forgot password link placeholder if needed */}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Login);